import { render, staticRenderFns } from "./TbBasicSync.vue?vue&type=template&id=ad232b56&scoped=true"
import script from "./TbBasicSync.vue?vue&type=script&lang=js"
export * from "./TbBasicSync.vue?vue&type=script&lang=js"
import style0 from "./TbBasicSync.vue?vue&type=style&index=0&id=ad232b56&prod&scoped=true&lang=css"
import style1 from "./TbBasicSync.vue?vue&type=style&index=1&id=ad232b56&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ad232b56",
  null
  
)

export default component.exports